const copyTextFromElementById = async (elementId) => {
  const copyText = document.getElementById(elementId);

  if (!copyText) return false;

  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(copyText.value || copyText.textContent);
      return true;
    } else {
      copyText.select();
      return document.execCommand('copy');
    }
  } catch (error) {
    console.error('Error copying text:', error);
    return false;
  }
}

export default copyTextFromElementById;

